import React from 'react';
import {
  Modal,
  Box,
  Typography,
  CircularProgress,
  Alert,
  IconButton,
  Button,
} from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import JSONPretty from 'react-json-pretty';
import 'react-json-pretty/themes/monikai.css';

/**
 * Modal component for displaying lead import processing logs
 */
const LogsModal = ({ open, onClose, loading, logs, error, filename }) => {
  return (
    <Modal open={open} onClose={onClose} aria-labelledby="logs-modal-title">
      <Box
        sx={{
          position: 'absolute',
          top: '50%',
          left: '50%',
          transform: 'translate(-50%, -50%)',
          width: '80%',
          maxWidth: 1000,
          maxHeight: '80vh',
          bgcolor: 'background.paper',
          borderRadius: 1,
          boxShadow: 24,
          p: 4,
          overflow: 'auto',
        }}
      >
        <Box
          sx={{
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
            mb: 2,
          }}
        >
          <Typography id="logs-modal-title" variant="h6" component="h2">
            Processing Logs - {filename}
          </Typography>
          <IconButton aria-label="close" onClick={onClose} size="small">
            <CloseIcon />
          </IconButton>
        </Box>

        {loading && (
          <Box sx={{ display: 'flex', justifyContent: 'center', my: 4 }}>
            <CircularProgress />
          </Box>
        )}

        {error && (
          <Alert severity="error" sx={{ my: 2 }}>
            {error}
          </Alert>
        )}

        {logs && (
          <Box
            sx={{ mt: 2, overflow: 'auto', maxHeight: 'calc(80vh - 120px)' }}
          >
            <JSONPretty id="json-pretty" data={logs}></JSONPretty>
          </Box>
        )}

        <Box sx={{ mt: 3, display: 'flex', justifyContent: 'flex-end' }}>
          <Button variant="contained" onClick={onClose} color="primary">
            Close
          </Button>
        </Box>
      </Box>
    </Modal>
  );
};

export default LogsModal;
